import { Alert, Box, Button, CircularProgress, Typography } from "@mui/material";
import type { ReactNode } from "react";

export function LoadingState({ label = "Loading…" }: { label?: string }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2, p: 4, justifyContent: "center" }}>
      <CircularProgress size={20} />
      <Typography color="text.secondary">{label}</Typography>
    </Box>
  );
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <Alert
      severity="error"
      action={onRetry && <Button color="inherit" size="small" onClick={onRetry}>Retry</Button>}
      sx={{ my: 2 }}
    >
      {message}
    </Alert>
  );
}

export function EmptyState({ title, description, action }: { title: string; description?: string; action?: ReactNode }) {
  return (
    <Box sx={{ textAlign: "center", p: 6, color: "text.secondary" }}>
      <Typography variant="h6" color="text.primary">{title}</Typography>
      {description && <Typography sx={{ mt: 1 }}>{description}</Typography>}
      {action && <Box sx={{ mt: 2 }}>{action}</Box>}
    </Box>
  );
}
